export const PXHomepageHeaderBanner = (function() {
	'use strict';

	var $btn;

	function init() {
		$btn = $('.btn--arrow-down');
		events();
	}

	function events() {
		$btn.on('click', function(e) {
			e.preventDefault();
			var $parent_block = $(this).parents('.pxblock');

			$('html,body').animate({
				scrollTop: $parent_block.next().offset().top
			}, 300);
		});
	}

	return {
		init: init
	};
})();
